import { SaveOutlined, SearchOutlined } from "@ant-design/icons";
import { Tag,Upload, Menu, Dropdown } from "antd";
import { UploadOutlined, CloseOutlined, FileOutlined, PlusOutlined, MinusCircleOutlined, MinusSquareOutlined } from '@ant-design/icons';
import { MdDelete, MdEdit } from "react-icons/md";
import { FiMoreHorizontal} from "react-icons/fi";
import axios from "axios";
import ImgCrop from 'antd-img-crop';

import {
  Button,
  DeleteButton,
  Form,
  Modal,
  Table,
  TableCard,
  Input,
  Drawer,
  Export,
} from "components";
import React, { useEffect, useState } from "react";
import { FaPen, FaPlus, FaDownload, FaFilter, FaCaretRight } from "react-icons/fa6";

import searchFields from "./searchFields";
import { Link } from "react-router-dom";

function User() {
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [form] = Form.useForm();
  const [ file, setFile ] = useState();
  const [ imageUrl, setImageUrl ] = useState();
  const [role, setRole] = useState([]);
  const [filterForm] = Form.useForm();
  const status = [
    { label: <Tag color="red">Идэвхигүй</Tag>, value: "Идэвхигүй"  },
    { label: <Tag color="processing">Идэвхитэй</Tag>, value: "Идэвхитэй" },
  ];

  useEffect(() => {
    getData();
    getRole();
  }, []);


  useEffect(() => {
    form.setFieldsValue({
    image: editData?.image,

    });
  },[form, data]);
    
  const getData = () => {
    setLoading(true);
    axios({
      method: "get",
      url: "users",
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  };
  const getRole = () => {
    axios({
      method: "get",
      url: "/roles",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({
            value: item.id,
            label: item.name,
            text: item.name,
          })
        );
        setRole(tmp);
      })
      .catch(() => {});
  };
 
  const columns = [
    {
      title: "№",
      dataIndex: "No",
      key: "No",
      width: 50,
      align: "center",
      cellRender: (e) => <span>{e.rowIndex + currentPage + 1}</span>,
    },
    {
      title: "Зураг",
      dataIndex: "image",
      key: "image",
      width: 50,
      cellRender: ({ value, data }) => (
        <div className="">
          <img src={`${process.env.REACT_APP_CDN_URL}${value}`} style={{width:'50px', height: "50"}} alt="" />
        </div>
      ),
    },
    {
      title: "Овог",
      dataIndex: "lastname",
      key: "lastname",
      cellRender: ({value, data}) => (
        <Link to={`/user/${data?.id}`}><div className="flex flex-row">
         <div className="action-cell flex items-center gap-2"><FaCaretRight />
        </div>{value}
        </div></Link>
      )
    },
    {
      title: "Нэр",
      dataIndex: "firstname",
      key: "firstname",
      cellRender: ({value, data}) => (
        <Link to={`/user/${data?.id}`}><div className="flex flex-row">
         <div className="action-cell flex items-center gap-2"><FaCaretRight />
        </div>{value}
        </div></Link>
      )
    },
    {
      title: "Утас",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Mэйл",
      dataIndex: "email",
      key: "email",
    
    },
    // {
    //   title: "Албан тушаал",
    //   dataIndex: "roleid",
    //   key: "roleid",
    //   cellRender: ({ value, data }) => (
    //     <>{role.find((item) => item?.value === value)?.label}</>
    //   ),
    // },
    {
      title: "Үүрэг",
      dataIndex: "rolename",
      key: "rolename",
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      cellRender: ({ value, data }) => (
        <>{status.find((item) => item?.value === value)?.label}</>
      ),
    },

    {
          title: "",
          dataIndex: "action",
          key: "action",
          width: 90,
          cellRender: ({ value, data }) => {
            // Dropdown menu items
            const menu = (
              <Menu>
                <Menu.Item key="1" icon={<MdEdit />} onClick={() => handleEditButton(data)}>
                  Edit
                </Menu.Item>
                <Menu.Item key="2" icon={<MdDelete/>} danger onClick={() => handleDelete(data)}>
                  Delete
                </Menu.Item>
              </Menu>
            );
      
            return (
              <div className="action-cell flex items-center gap-2 " >
                <Dropdown overlay={menu} trigger={['click']}>
                  <Button
                    type="ghost"
                    size="sm"
                    icon={<FiMoreHorizontal style={{fontSize : '8px', width: "16px"}}/>}
                  />
                </Dropdown>
              </div>
            );
          },
        }
  ];

  const fields = [
    {
      label: "Овог",
      name: "lastname",
      rules: [{ required: true, message: "Овог оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {},
    },
    {
      label: "Нэр",
      name: "firstname",
      rules: [{ required: true, message: "Нэр оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {},
    },
    {
      label: "Утас",
      name: "mobile",
      type: 'number',
      // rules: [{ required: true, message: "Утас оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {},
    },
    {
      label: "Үүрэг",
      name: "roleid",
      type: 'select',
      rules: [{ required: true, message: "Албан тушаал оруулна уу" }],
      className: "col-span-6 mb-1",
      inputProps: {
        options: role
      },
    },
    {
      label: "Төлөв",
      name: "status",
      type: 'select',
      rules: [{ required: true, message: "Төлөв оруулна уу" }],
      className: "col-span-6 mb-1",
      inputProps: {
        options: status
      },
    },
    {
      label: "Цахим шуудан",
      name: "email",
      rules: [{ required: true, message: "Цахим шуудан оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {
      },
    },
    {
      label: "Нууц үг",
      name: "password",
      type: "password",
      // rules: [{ required: true, message: "Нууц үг оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {
      },
    },
    {
      label: "Зураг",
      name: "image",
      type: 'image',
      // rules: [{ required: true, message: "Зураг оруулна уу" }],
      className: "col-span-12 mb-1",  
      inputProps: {
      },
    },
    // {
    //   type:'component',
    //   component:<div className="col-span-12">
    //     <Form.Item name="image">
    //         <Upload name="image" action="/upload" type="drag" listType="picture" 
    //             maxCount={1} 
    //             fileList={form.getFieldValue("image")} 
    //             onChange={handleImageChange}
    //             >
    //               <img src={file ? file : `${process.env.REACT_APP_CDN_IMG}${data?.logo}`} width={240} height={240} className='rounded-full'/>
    //             <div className='absolute bottom-0 left-0 right-0 top-0 rounded-full w-full h-full opacity-50 bg-black'></div>
    //             <div className='absolute bottom-0 left-0 right-0 top-0 grid place-items-center'>
    //               <label className='border border-white rounded-2xl px-4 py-2 text-white text-xl font-medium cursor-pointer' for="logo">Зураг солих</label>
    //             </div>           
    //           </Upload>
    //       </ImgCrop>
    //       <img src={file ? file : `${process.env.REACT_APP_CDN_IMG}${editData?.image}`} width={100} height={100} className='rounded-full'/>
    //     </Form.Item>
    //   </div>
    // }
  ];
  
  const handleSubmit = (values) => {
    setActionLoading(true);
    const formData = new FormData();
    let keys = Object.keys(values);
    keys.map((item) => {
      if (item !== "image") {
        formData.append(item, values[`${item}`] || "");
      }
    });
    // formData.set('image', values.image[0].originFileObj ? values.image[0].originFileObj : '');
    formData.append(
      "image",
      values.image ? values.image[0]?.originFileObj : ""
    );
    if (!values.password) {
      values.password = null;
    }
    console.log(values);
    if (editData) {
      if (!values.password) {
        values.password = null;
      }
      // formData.set('image', imageUrl ? imageUrl : '');
      formData.append("id", editData.id);
      // formData.append(
      //   "image",
      //   values.image ? values.image[0]?.originFileObj : ""
      // );
      axios({ 
        method: "put",
        url: `/user`,
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
    } else {
      axios({
        method: "post",
        url: `/user`,
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
    }
  };
  
  const handleAddButton = (data) => {
    setEditData(null);
    setShowModal(true);
    // handleImageChange();
  };

  // const handleImageChange = ({ fileList }) => {
  //   form.setFieldsValue({ image: fileList }); 
  // };
  const handleEditButton = (data) => {
    console.log(data)
    setEditData(data);
    setShowModal(true);
  };
  const handleDelete = (data) => {
    setActionLoading(true);
    axios({
      method: "delete",
      url: `/users/${data.id}`,
    })
      .then((res) => {
        getData();
        handleCancel();
      })
      .finally(() => {
        setActionLoading(false);
      });
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
    if (editData) {
      setEditData(null);
    } else {
      form.resetFields();
    }
  };

  const handleFilterSubmit = (values) => {
    setLoading(true);
    axios({
      method: "get",
      url: `/user_search`,
      params: values
    })
      .then((res) => {
        setData(res.data);
        setFilterOpen(false);
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  };
  console.log(editData);
  return (
    <TableCard
      header={
        <div className='flex flex-col'>
          <div className='w-full flex justify-between items-center gap-4'>
          <h1 className='text-2xl font-medium'>Ажилчдын жагсаалт</h1>
            <div className='flex items-center gap-2'>
              <Button icon={<FaFilter/>} onClick={() => setFilterOpen(true)}>Шүүлтүүр</Button>
              <Export
                fileData={data} 
                fileName={'Хэрэглэгч'} 
              />
              <Button type='primary' icon={<FaPlus/>}  onClick={handleAddButton}>Нэмэх</Button> 
            </div>          
          </div>
        </div>
      }
    >
      <Table dataSource={data} columns={columns} loading={loading} />
      <Modal
        title={editData ? "Засах" : "Шинээр нэмэх"}
        open={showModal}
        onCancel={handleCloseModal}
      >
        <Form
          form={form}
          fields={fields}
          editData={editData}
          onFinish={handleSubmit}
          className={"gap-2"}
        >
          <div className="col-span-12 flex justify-end items-center gap-2 mt-5">
            <Button
              type="primary"
              onClick={() => form.submit()}
              loading={actionLoading}
              icon={<SaveOutlined />}
            >
              Хадгалах
            </Button>
            <Button onClick={handleCancel} disabled={actionLoading}>
              Цуцлах
            </Button>
          </div>
        </Form>
      </Modal>
      <Drawer open={filterOpen} onClose={() => setFilterOpen(false)}>
        <div>
          <h1 className="text-xl text-black-text font-bold">Шүүх</h1>
          <Form
            form={filterForm}
            fields={searchFields({
              status : status
            })}
            onFinish={handleFilterSubmit}
            className="gap-4"
          />
          <Button
            className="w-full mt-4"
            size="sm"
            type="primary"
            onClick={() => filterForm.submit()}
          >
            Хайх
          </Button>
        </div>
      </Drawer>
    </TableCard>
  );
}

export default User;
